export default __webpack_public_path__ + "static/media/money-back@2x.89fa8c2b.png";